const ShowCardOptions = {
  ALL_CARDS: "all",
  SELECTED_CARDS: "selected"
} as const;

const ALL = Object.values(ShowCardOptions);

export default { ...ShowCardOptions, ALL };
